import 'regenerator-runtime/runtime';
export { i as default } from './onboard-5c0e3ad5.js';
import 'bignumber.js';
import 'bnc-sdk';
import 'bowser';